import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Flex,
  Text,
} from "@chakra-ui/react";

function ClosePopup(props) {
  return (
    <>
      <Modal
        isOpen={props.isOpen}
        onClose={props.onClose}
        isCentered
        size="xl"
        blockScrollOnMount
        preserveScrollBarGap
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>We are currently closed!</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction="column">
              <Text fontWeight={700} mb="0.5rem">
                Business Hours
              </Text>
              <Text fontSize="15px">Monday - Friday</Text>
              <Text fontSize="15px">
                <b>Lunch:</b> 11:00AM - 2:00PM
              </Text>
              <Text fontSize="15px">Monday - Sunday</Text>
              <Text fontSize="15px">
                <b>Dinner:</b> 3:00PM - 9:30PM
              </Text>
            </Flex>
          </ModalBody>

          <ModalFooter justifyContent="flex-start">
            <Flex direction="column">
              <Text fontSize="14px">
                *Last call for online orders at 1:45PM and 9:15PM
              </Text>
              <Text fontSize="14px">
                **The above is subject to change at any given time
              </Text>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ClosePopup;
